import React from "react";
import "../styles/Artists.scss";
import photographers from "../data/photographers.json";
import film from "../data/film.json";
import "video.js/dist/video-js.css";

import Header from "./Header";

const artistsJson = {
  photographers: photographers,
  film: film,
};

class PhotographersLanding extends React.Component {
  render() {
    let artistsThumbs = artistsJson[this.props.json].map((item) => {
      return (
        <a
          href={`http://${item.website}`}
          className="artists-thumb"
          target="_blank"
          key={item.id}
        >
          <div className="artists-thumb-image">
            <img
              className="img-desktop"
              src={`${process.env.PUBLIC_URL}${item.thumb}`}
            />

            <img
              className="img-mobile"
              src={`${process.env.PUBLIC_URL}${item.mobileBG}`}
            />
          </div>
          <div className="artists-thumb-text">
            <h3>{item.name}</h3>
          </div>
        </a>
      );
    });

    return (
      <div>
        <Header />
        <div className={`container ${this.props.json}`}>
          <h1 className="heading serif-font">
            Artists &mdash;{" "}
            <span className="serif-italic-font">{this.props.title}</span>
          </h1>
          <div className="artists-thumbs">{artistsThumbs}</div>
        </div>
      </div>
    );
  }
}

export default PhotographersLanding;
